var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7292F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3,
    fill: "inheirt"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0935 14.1738L8.00834 12.2254C7.77599 12.0083 7.40661 12.0083 7.17426 12.2254C6.94191 12.4425 6.94191 12.7877 7.17426 13.0048L9.67054 15.3372C9.90289 15.5543 10.2782 15.5543 10.5106 15.3372L16.8257 9.44215C17.0581 9.22505 17.0581 8.87992 16.8257 8.66282C16.5934 8.44573 16.224 8.44573 15.9917 8.66282L10.0935 14.1738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.3858d09e278807a4150be7ca8083a1a4.svg";
export { ForwardRef as ReactComponent };